<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <input
        id="form-element-{{ formField.id }}"
        type="tel"
        autocomplete="tel"
        name="phone-number"
        class="form-control"
        #field="ngModel"
        appFocus
        [appAutoFocus]="formField.isNeedToFocus"
        sbIntlTelInput
        [intlTelInputOptions]="cellInputConfig"
        (keypress)="validatePhonePattern($event)"
        (hasError)="hasError($event)"
        (intlTelOutput)="setNationalNumber($event)"
        [ngClass]="{
            'ng-invalid':
                formService.isSubmitted &&
                ((formField.value && field.errors?.pattern) || (formField.isRequired && !formField.value)),
        }"
        [(ngModel)]="formField.value"
        [required]="formField.isRequired"
        [placeholder]="formField.placeholder"
        [maxlength]="20" />

    @if (!formField.value && formField.isRequired && formService.isSubmitted) {
        <div class="text-danger">{{ 'Please fill this field' | translate }}</div>
    }
    @if (field.value && field.errors?.pattern && formService.isSubmitted) {
        <div class="text-danger">{{ 'Please check your phone number and try again' | translate }}</div>
    }
</div>
